import React from "react";
import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Files from "react-files";
import {
  getDictationMedCodes,
  getDSProcessedDictation,
  uploadDocument,
} from "apiHandler/actions";
import RefreshIcon from "@material-ui/icons/Refresh";
import PracticeDocumentModal from "components/modals/PracticeDocument";
import MedCodes from "components/scribe/MedCodes";
import PersonalInfo from "components/scribe/PersonalInfo";
import PatientNotes from "components/scribe/PatientNotes";
import PatientDetails from "components/scribe/PatientDetails";
import EncounterInfo from "components/scribe/EncounterInfo";
import { useUserData } from "components/customHooks/userDataContext";
import { BackButton } from "components/helpers";
import PersistentDrawerLeft from "components/UI/PersistentDrawerLeft";
import HomeIcon from "@mui/icons-material/Home";
import AuditHistoryModal from "components/modals/AuditHistory";

const Dictated = () => {
  const location = useLocation();
  //console.log("location", location);
  const navigate = useNavigate();
  const [details, setDetails] = useState(location.state);
  const [medCodes, setMedCodes] = useState([]);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [suggDiag, setSuggDiag] = useState([]);
  const [suggProce, setSuggProce] = useState([]);
  const [loading, setLoading] = useState(false);
  const [practiceDoc, setPracticeDoc] = useState(null);
  const [showPracticeDoc, setShowPracticeDoc] = useState(false);
  const [audit, setAudit] = useState(null);
  const [encounter_id, setEncounterId] = useState(
    location?.state?.encounter_id,
  );
  const [medCodeError, setMedCodeError] = useState("");
  const [htmlData, setHtmlData] = useState("");
  const [htmlLoading, setHtmlLoading] = useState(true);
  const userData = useUserData();

  useEffect(() => {
    if (details) fetchCodes();
  }, []);

  useEffect(() => {
    navigate(location.pathname, {
      replace: true,
      state: { ...details },
      ...location,
    });
  }, [details]);

  const fetchCodes = async () => {
    const token = userData?.access_token;

    const { id } = details;
    const dsPayload = {
      dictation_id: id.toString(),
      practice_id: userData?.selected_practice,
    };

    const htmlResponse = await getDSProcessedDictation(dsPayload, token);
    const payload = {
      type: "Dictation",
      search_criteria: {
        dictation_id: id.toString(),
        practice_id: userData?.selected_practice,
      },
    };
    const response = await getDictationMedCodes(payload, token);
    if (Array.isArray(response)) setMedCodes(response);
    else setMedCodeError(`Failed to get Medical Codes: ${response?.error}`);
    setHtmlData(htmlResponse || "");
    setHtmlLoading(false);
  };

  const onFilesChange = (files) => {
    if (files.length > 0) {
      const payload = {
        type: "Documents",
        document_type: "Medical Record Attachment",
        encounter_id: encounter_id,
        practice_id: details.practice_id,
        document_type_id: 30,
      };
      uploadDocument(payload, files[0], userData?.billing_access_token);
    }
  };

  const onFilesError = (error) => {
    if (error.code === 4) return;
    if (error) {
      return alert(error.message);
    }
  };

  if (!details) return <Navigate to="/scribe-status-list" replace />;
  else {
    const readOnly = details.status === "Completed";
    return (
      <div className="dictated-container">
        <div className="header">
          <BackButton onClick={() => navigate(-1)} />
          <div className="btn-cont">
            <button
              className="blank-hover-btn"
              onClick={() => window.location.reload()}
            >
              <RefreshIcon color="secondary" style={{ fontSize: "16px" }} />
            </button>
            <Files
              className="blank-hover-btn"
              onChange={onFilesChange}
              onError={onFilesError}
              accepts={[
                ".pdf",
                "image/png",
                "image/jpg",
                "image/jpeg",
                "image/tiff",
              ]}
              multiple
              maxFiles={1}
              maxFileSize={10000000}
              minFileSize={0}
              clickable
            >
              Upload Document
            </Files>

            <button
              className="blank-hover-btn"
              onClick={() => setShowHistoryModal(true)}
            >
              Audit History
            </button>
            <button
              className="blank-hover-btn"
              onClick={() => setShowPracticeDoc(true)}
            >
              Practice Documents
            </button>
          </div>
        </div>
        <button
          style={{
            position: "fixed",
            borderWidth: 0,
            marginLeft: "-10px",
            right: "10px",
            top: window.innerHeight / 2,
            height: "40px",
            width: "40px",
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
          onClick={() => navigate("/scribe-dictations")}
        >
          <HomeIcon color="secondary" fontSize="medium" />
        </button>
        <div>
          <PersistentDrawerLeft
            html={htmlData}
            MedCodes={MedCodes}
            PersonalInfo={PersonalInfo}
            PatientNotes={PatientNotes}
            PatientDetails={PatientDetails}
            EncounterInfo={EncounterInfo}
            details={details}
            setDetails={setDetails}
            medCodes={medCodes}
            suggDiag={suggDiag}
            setSuggDiag={setSuggDiag}
            suggProce={suggProce}
            setSuggProce={setSuggProce}
            loading={loading}
            setLoading={setLoading}
            setEncounterId={setEncounterId}
            medCodeError={medCodeError}
            readOnly={readOnly}
            location={location}
            encounter_id={encounter_id}
            isHtmlLoading={htmlLoading}
          />
        </div>

        {showHistoryModal && (
          <AuditHistoryModal
            audit={audit}
            setAudit={setAudit}
            onClose={() => setShowHistoryModal(false)}
            id={details.id}
          />
        )}
        {showPracticeDoc && (
          <PracticeDocumentModal
            practice_id={details.practice_id}
            documents={practiceDoc}
            setDocuments={setPracticeDoc}
            onClose={() => setShowPracticeDoc(false)}
          />
        )}
      </div>
    );
  }
};

export default Dictated;
